import React from 'react';
import { ThumbsUp, Heart, Laugh, Lightbulb, Flame, Eye, Check, Sparkles } from 'lucide-react';

/**
 * Reaction key → MONOCHROME Lucide icon. We render reactions as grayscale icons (not colorful
 * emoji) so the UI stays monochrome and generated media is what draws the eye (Medium-clap
 * aesthetic: minimal icon + count + names on hover). Mirrors the server allowlist
 * (`functions/src/constants/emoji.ts`); keep the two lists in sync.
 */
export const REACTION_ICONS: Record<string, React.FC<{ className?: string }>> = {
  clap: Sparkles, // appreciation / applause (Medium-style "clap")
  up: ThumbsUp,
  love: Heart,
  laugh: Laugh,
  idea: Lightbulb,
  fire: Flame,
  eyes: Eye,
  check: Check,
};

/** Ordered keys for the picker. */
export const REACTION_KEYS = ['clap', 'up', 'love', 'laugh', 'idea', 'fire', 'eyes', 'check'] as const;

/** Human label (for a11y / title on the picker buttons). */
export const REACTION_LABEL: Record<string, string> = {
  clap: 'Appreciate', up: 'Agree', love: 'Love', laugh: 'Funny',
  idea: 'Insightful', fire: 'Great', eyes: 'Watching', check: 'Done',
};
